import React from "react";
import { Theme } from "../types/types";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  theme: Theme;
  fullWidth?: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  theme,
  fullWidth = false,
}) => {
  return (
    <input
      type="text"
      placeholder="Search..."
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        backgroundColor: theme.surface,
        color: theme.text,
        border: `1px solid ${theme.border}`,
        borderRadius: "6px",
        padding: "6px 12px",
        fontSize: "14px",
        outline: "none",
        width: fullWidth ? "100%" : "180px",
        boxSizing: "border-box",
      }}
    />
  );
};
